'use strict';

;(function () {
  /* ----- Constants & Variables -----*/
  
  let rechargeLoginContainer;

  /* ----- Functions & Methods -----*/

  function insertCustomData(){
    const inputRechargeBtnTextT = document.querySelector('#recharge-get-access-btn-text-t');
    const inputRechargeInstructionsT = document.querySelector('#recharge-get-access-instructions-t');
    const RECHARGE_INSTRUCTIONS_T = inputRechargeInstructionsT.value;
    const RECHARGE_BTN_SEND_TXT_T = inputRechargeBtnTextT.value;
    let loginHeadingElem = rechargeLoginContainer.querySelector('.rc-login--header-title');
    let newParagraph = document.createElement('p');
    
    newParagraph.classList.add('rc-instructions');
    newParagraph.innerText = RECHARGE_INSTRUCTIONS_T;
    insertAfter(loginHeadingElem, newParagraph);

    document.querySelector('.rc-login-form-button').innerText = RECHARGE_BTN_SEND_TXT_T;
  }

  function insertAfter(elem, newElem) {
    elem.parentNode.insertBefore(newElem, elem.nextSibling);
  }

  /* ----- Events -----*/
  function onDocumentLoaded(){
    if(!location.href.toLowerCase().includes('get-subscription-access') && !location.href.toLowerCase().includes('/tools/recurring/login/')){
      return;
    }

    rechargeLoginContainer = document.querySelector('.rc-login');

    insertCustomData();
  }
  
  if(document.readyState != 'loading'){
    onDocumentLoaded();
  } else {
    document.addEventListener("DOMContentLoaded", onDocumentLoaded);
  }
})();